<script>
  import { displayTimeAgo } from 'components/Helper.js';
  import { navigate } from 'svelte-routing';
  export let message;
  export let time;
  export let timeAgoStr;
  export let url = '';
  import { unreadCount } from '../../stores/unreadCount';
  import { client } from 'root/api/index.js';
  export let item;
  import * as bootstrap from 'bootstrap';
  import { onDestroy, onMount } from 'svelte';
  let tooltipTriggerEl, tooltipEl;
  onMount(() => {
    if (tooltipTriggerEl) {
      tooltipEl = new bootstrap.Tooltip(tooltipTriggerEl, {
        delay: 100,
        html: true,
      });
    }
  });
  onDestroy(() => {
    if (tooltipTriggerEl) {
      tooltipEl.hide();
    }
  });
</script>

<button
  disabled={url == ''}
  class="view-btn mb-0 bg-transparent border-0 w-100 p-0 m-0 text-start btn-notifications"
  on:click={() => {
    if (item.read == 0) {
      unreadCount.set($unreadCount - 1);
      client.notificationRead({
        notifications: [{ id: item.notificationUserId }],
      });
    }
    navigate(url);
  }}
>
  <div class="bg-white task-item d-flex flex-row mb-3 align-items-center justify-content-between">
    <div class="d-flex flex-row align-items-center">
      <div class="overdue-task-block">
        <div class="overdue-task d-block text-break">
          <span>{@html message}</span>
          {#if item.showTooltip == 1}
            <button
              class="btn btn-link d-inline-block p-0"
              bind:this={tooltipTriggerEl}
              data-bs-placement="bottom"
              title={item.tooltip}
              ><img
                class=" icon-14"
                alt=""
                src="/images/info.svg"
              /></button
            >
          {/if}
        </div>
      </div>
    </div>

    <div class="task-time">
      <img
        class="me-1 icon-14"
        alt=""
        src="./images/clock.svg"
      />
      <small class="text-muted">{timeAgoStr}</small>
    </div>
  </div>
</button>

<style lang="scss">
  .btn-notifications {
    &:hover {
      color: $blue-color;
    }
    &:disabled {
      color: #181c32;
    }
    .task-item {
      box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
      padding: 17px;
      border-radius: 4px;
      transition: 0.3s;
      &:hover {
        box-shadow: 0 6px 12px rgba(140, 152, 164, 0.25) !important;
      }

      .overdue-task {
        font-weight: 500;
      }
      .overdue-task-block {
        font-size: 14px;
        line-height: 15px;
      }
      .task-time {
        flex: 0 0 150px;
        width: 150px;
        text-align: right;
        img {
          width: 16px;
        }
      }
    }
  }
</style>
